module.exports = __webpack_public_path__ + "static/media/Giddyapp_2.9ba9ae13.png";